import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-progress',
	templateUrl: './item-progress.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ItemProgressComponent implements OnInit {
	
	@Input() max: any;
	@Input() value: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.percent = (this.vm.value / this.vm.max * 100).toFixed(1);
		
		if (this.vm.percent > 75) {
			this.vm.variant = 1;
		} else if (this.vm.percent > 50) {
			this.vm.variant = 2;
		} else {
			this.vm.variant = 3;
		}
	}
	
}